module.exports = __webpack_public_path__ + "static/img/ordericon2.45277a53.png";